import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlumnosContext } from '../../context/alumnos/AlumnosContext';
import ActionsDropdown from '../Alumnos/ActionsDropdown/ActionsDropdown';
import Botonera from '../Alumnos/Botonera/Botonera';
import Avatar from './Avatar';
import FiltrosAlumnos from '../Alumnos/ABM/FiltrosAlumnos';
import Formulario from '../Alumnos/ABM/Formulario';
import Spinner from '../Layout/Spinner';

export default function Tabla({
	data,
	columns,
	options,
	asistencia,
	pagos,
	ficha,
	alumno,
}) {
	const alumnoCtx = useContext(AlumnosContext);
	const { updateAlumno, deleteAlumno, handlePagos, suspendAlumno, data: dataForm, createAlumno, loading } = alumnoCtx;
	const [filtros, setFiltros] = useState({
		categoria: '',
		nombre: '',
		apellido: '',
		grupo: '',
		añoNacimiento: ''
	});
	const [datosFiltrados, setDatosFiltrados] = useState([]);
	const [montos, setMontos] = useState({});
	const [añoSeleccionado, setAñoSeleccionado] = useState(new Date().getFullYear());
	const [showModal, setShowModal] = useState(false);
	const [editingId, setEditingId] = useState(null);

	const functions = { updateAlumno, deleteAlumno, suspendAlumno, handleOpenEditModal: (id) => handleOpenEditModal(id) };

	const handleOpenEditModal = (id) => {
		setEditingId(id);
		setShowModal(true);
	};

	const sendData = async (event) => {
		event.preventDefault();
		if (editingId) {
			await updateAlumno(editingId, dataForm);
		} else {
			await createAlumno(dataForm);
		}
		setShowModal(false);
	};

	const pagosYAsistencias = () => {
		return datosFiltrados.map((e) => {
			// const badge = () => {

			//   return e.estado === "pago" ? (
			//     <span className="badge text-bg-success">
			//       {e.estado.toUpperCase()}
			//     </span>
			//   ) : (
			//     <span className="badge text-bg-danger">
			//       {e.estado.toUpperCase()}
			//     </span>
			//   );
			// };

			const handleRowColor = () => {
				return e.asistencia.includes(new Date().toLocaleDateString())
					? '#b1d7c0'
					: '#d7a2a2';
			};
			return (
				<tr
					key={e.id}
					style={{
						backgroundColor: asistencia ? handleRowColor() : '#FFFFFF',
					}}
				>
					<td>
						<Avatar
							width='40px'
							src={e.avatar}
							alt={`avatar ${e.nombre} ${e.apellido}`}
						/>
						<Link to={`/alumno/${e.id}`}>
							{e.nombre} {e.apellido}
						</Link>
					</td>
					<td>{e.fechaNacimiento ? new Date(e.fechaNacimiento).getFullYear() : '-'}</td>
					{/* <td>{badge()}</td> */}
					<td style={{ display: 'flex', justifyContent: 'end' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								gap: '10px',
							}}
						>
							<Botonera asistencia={asistencia} pagos={pagos} id={e.id} />
							{options && <ActionsDropdown functions={functions} id={e.id} />}
						</div>
					</td>
				</tr>
			);
		});
	};
	const tablaFicha = () => {
		const handleMontoChange = (mes, valor) => {
			setMontos((prev) => ({ ...prev, [mes]: valor }));
		};
		const celdas = columns.map((mes, idx) => {
			return (
				<td key={idx}>
					<div className='d-flex flex-column align-items-center'>
						<input
							className='inputFicha'
							type='text'
							value={montos[mes.text] || ''}
							onChange={(e) => handleMontoChange(mes.text, e.target.value)}
							onClick={(e) => e.target.select()}
						/>
						<button
							className='btn btn-success mt-1'
							onClick={() => handlePagos(alumno.id, montos[mes.text], mes.text, añoSeleccionado)}
						>
							GUARDAR
						</button>
					</div>
				</td>
			);
		});

		return <tr>{celdas}</tr>;
	};

	useEffect(() => {
		const montosIniciales = {};
		
		if (ficha && alumno) {
			// Filtrar pagos por año seleccionado y compatibilidad con formatos legacy
			const pagosFiltrados = alumno.pagos.filter((pago) => {
				// Nuevo formato: mes y año
				if (pago.mes && pago.año) {
					return pago.año === añoSeleccionado;
				}
				// Formato legacy intermedio: mesPago2025 (asumir año 2025)
				if (pago.mesPago2025 && añoSeleccionado === 2025) {
					return true;
				}
				// Formato legacy más antiguo: mesPago (extraer año de la fecha o asumir 2024)
				if (pago.mesPago) {
					if (pago.fecha) {
						const fechaParts = pago.fecha.split('/');
						if (fechaParts.length === 3) {
							const añoDeFecha = parseInt(fechaParts[2]);
							if (!isNaN(añoDeFecha)) {
								return añoDeFecha === añoSeleccionado;
							}
						}
					}
					// Si no hay fecha o no se puede extraer, asumir año 2024
					return añoSeleccionado === 2024;
				}
				return false;
			});
			
			pagosFiltrados.forEach((pago) => {
				// Obtener mes del pago (nuevo formato, legacy intermedio, o legacy más antiguo)
				const mes = pago.mes || pago.mesPago2025 || pago.mesPago;
				if (mes) {
					montosIniciales[mes] = pago.monto;
				}
			});
		}
		
		setMontos(montosIniciales);
	}, [alumno, añoSeleccionado, ficha]);

	return (
		<div style={{ margin: '10px' }}>
			{!ficha && (
				<FiltrosAlumnos
					alumnos={data}
					filtros={filtros}
					setFiltros={setFiltros}
					setAlumnosFiltrados={setDatosFiltrados}
				/>
			)}
			{ficha && (
				<div style={{ marginBottom: '10px' }}>
					<label style={{ marginRight: '10px' }}>Año:</label>
					<select
						value={añoSeleccionado}
						onChange={(e) => setAñoSeleccionado(parseInt(e.target.value))}
						className='form-select'
						style={{ width: '150px', display: 'inline-block' }}
					>
						{Array.from({ length: 5 }, (_, i) => {
							const año = new Date().getFullYear() - 2 + i;
							return (
								<option key={año} value={año}>
									{año}
								</option>
							);
						})}
					</select>
				</div>
			)}
			<table className='table table-striped fluid'>
				<thead>
					<tr>
						{columns.map((e) => {
							return (
								<th key={e.text} scope='col'>
									{e.text}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{loading && !ficha ? (
						<tr>
							<td colSpan={columns.length}>
								<Spinner />
							</td>
						</tr>
					) : !ficha ? (
						pagosYAsistencias()
					) : (
						tablaFicha()
					)}
				</tbody>
			</table>

			{/* Bootstrap Modal */}
			{showModal && (
				<div
					className='modal fade show'
					style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
					tabIndex='-1'
				>
					<div className='modal-dialog modal-lg'>
						<div className='modal-content'>
							<div className='modal-header'>
								<h5 className='modal-title'>
									{editingId ? 'Editar Alumno' : 'Nuevo Alumno'}
								</h5>
								<button
									type='button'
									className='btn-close'
									onClick={() => setShowModal(false)}
								></button>
							</div>
							<div className='modal-body'>
								<Formulario 
									titulo={editingId ? 'Editar Alumno' : 'Crear nuevo alumno'} 
									handleSubmit={sendData} 
									alumnoId={editingId}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
